module.exports = __webpack_public_path__ + "static/img/goodlife_logo.b0dd0ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goodlife_logo.png
// module id = 297
// module chunks = 1